import { z } from 'zod'

/**
 * Turns off zod's JIT before any schema exists.
 *
 * On the first `z.object()` zod probes for eval with a `new Function('')` inside a
 * try/catch, to decide whether it may compile a fast-path parser. Our CSP has no
 * 'unsafe-eval' (vite/csp.ts), so the probe throws, zod catches it and falls back to
 * the interpreter — validation is unaffected — but the browser still reports a
 * Content-Security-Policy violation on every page load, which reads as a real
 * failure in a console and in any CSP report a host collects.
 *
 * `jitless` skips the probe. The decision is taken per schema at construction, so
 * this must run before any module that builds one. main.tsx imports it, and
 * vite.config.ts places it in zod's own chunk: import order alone is not enough,
 * because a chunk's imports run before its body.
 */
z.config({ jitless: true })
